import type { MemberFilters } from '#utils/memberUtils';
import { convertLastSeenDateToUnix } from '#utils/memberUtils';

enum MemberInstructionKindForAddingToTeams {
  ADD_SOME_MEMBERS_TO_TEAMS = 'addMembersToTeams',
  ADD_ALL_MEMBERS_TO_TEAMS = 'addAllMembersToTeams',
}

export function getBulkAddMembersToTeamsSemanticPatchInstructions(
  memberIDs: string[],
  teamKeys: string[],
  filter: MemberFilters,
  ignoredMemberIDs?: string[],
) {
  const instructions = [];
  let filtersApplied = {};
  const filterQuery = filter?.get('query');
  const filterRoles = filter?.get('roles').toArray();
  const filterTeamKey = filter?.get('team');
  const filterLastSeenValue = filter?.get('lastSeen');
  let filterLastSeen;
  if (filterLastSeenValue) {
    if (filterLastSeenValue === 'never') {
      filterLastSeen = { never: true };
    } else if (filterLastSeenValue === 'no-data') {
      filterLastSeen = { noData: true };
    } else {
      // construct the object that gets sent to the BE
      filterLastSeen = {
        before: convertLastSeenDateToUnix(filterLastSeenValue),
      };
    }
    filtersApplied = { ...filtersApplied, filterLastSeen };
  }
  if (filterQuery) {
    filtersApplied = { ...filtersApplied, filterQuery };
  }
  if (filterRoles?.length) {
    filtersApplied = { ...filtersApplied, filterRoles };
  }
  if (filterTeamKey) {
    filtersApplied = { ...filtersApplied, filterTeamKey };
  }
  if (memberIDs[0] !== '*') {
    instructions.push({
      kind: MemberInstructionKindForAddingToTeams.ADD_SOME_MEMBERS_TO_TEAMS,
      memberIDs,
      teamKeys,
    });
  } else if (memberIDs[0] === '*') {
    instructions.push({
      kind: MemberInstructionKindForAddingToTeams.ADD_ALL_MEMBERS_TO_TEAMS,
      ignoredMemberIDs,
      teamKeys,
      ...filtersApplied,
    });
  }
  return instructions;
}
